import { useQuery } from '@tanstack/react-query';
import { getLoyaltyUser } from '../../../../../services/loyalty';
import useSession from '../../../../../stores/session/useSession';

export function getFindLoyaltyUserByIdQueryOptions() {
  const { user } = useSession();
  return {
    queryKey: ['wallet-user', user?._id],
    queryFn: () => getLoyaltyUser(user!._id),
    disabled: !!user?._id,
  };
}

export default function useFindLoyaltyUserByIdQuery() {
  return useQuery(getFindLoyaltyUserByIdQueryOptions());
}
